import PaymentPage from '@/pages/payment/layout.vue'
import PaymentListPage from '@/pages/payment/list/layout.vue'
import PaymentPeriodPage from '@/pages/payment/period.vue'
import PaymentListEventPage from '@/pages/payment/list/event.vue'
import PaymentListServicePage from '@/pages/payment/list/service.vue'
import PaymentListProductPage from '@/pages/payment/list/product.vue'
import PaymentListOnlinePage from '@/pages/payment/list/online.vue'
import PaymentListOfflinePage from '@/pages/payment/list/offline.vue'
import PaymentListTrashPage from '@/pages/payment/list/trash.vue'
import PaymentListStatisticPage from '@/pages/payment/list/statistic.vue'
import PaymentListAllPage from '@/pages/payment/list/all.vue'
// view, update, delete
import PaymentCreatePage from '@/pages/payment/create.vue'
import PaymentDetailPage from '@/pages/payment/detail/layout.vue'
import PaymentDetailUpdatePage from '@/pages/payment/detail/update.vue'
const routes = {
	path: '/payments',
	component: PaymentPage,
	children: [
		{
			path: 'create',
			component: PaymentCreatePage,
			meta: {title: 'Создание платежа', breadcrumb: 'Создание платежа'}
		}, {
			path: 'details/:id',
			component: PaymentDetailPage,
			meta: (route) => ({ title: 'Платёж' + route.params.id }),
			children: [
				{
					path: 'update',
					component: PaymentDetailUpdatePage,
					meta: (route) => ({ title: 'Платёж #' + route.params.id + ' | Платежи' })
				}
			]
		},
		{
			path: 'list',
			component: PaymentListPage,
			meta: {title: 'Платежи', breadcrumb: 'Платежи'},
			children: [
				{
					path: 'event',
					component: PaymentListEventPage,
					meta: {title: 'Мероприятия', breadcrumb: 'Мероприятия'}
				},
				{
					path: 'service',
					component: PaymentListServicePage,
					meta: {title: 'Услуги', breadcrumb: 'Услуги'}
				},
				{
					path: 'product',
					component: PaymentListProductPage,
					meta: {title: 'Продукты', breadcrumb: 'Продукты'}
				},
				{
					path: 'online',
					component: PaymentListOnlinePage,
					meta: {title: 'Онлайн', breadcrumb: 'Онлайн'}
				},
				{
					path: 'offline',
					component: PaymentListOfflinePage,
					meta: {title: 'Офлайн', breadcrumb: 'Офлайн'}
				},
				{
					path: 'trash',
					component: PaymentListTrashPage,
					meta: {title: 'Свалка', breadcrumb: 'Свалка'}
				},
				{
					path: 'statistic',
					component: PaymentListStatisticPage,
					meta: {title: 'Отчётность', breadcrumb: 'Отчётность'}
				},
				{
					path: 'all',
					component: PaymentListAllPage,
					meta: {title: 'Все отмечанные', breadcrumb: 'Все отмечанные'}
				}
			]
		},
		{
			path: 'periods',
			component: PaymentPeriodPage,
			meta: {title: 'Периоды', breadcrumb: 'Платежи'}
		}
	]
}
export default {
	routes
}



// WEBPACK FOOTER //
// ./src/routes/payment.js